module.exports = __webpack_public_path__ + "img/1451199-98-6.10dadbc8.png";